import "../stakeholderlayout.css";

export default function Governments() {
  return (
    <section className="page-wrapper">
      <div className="container">

        {/* Hero Section */}
        <h2 className="hero-title">
          Policy & Public Systems Support for Governments
        </h2>

        <h3 className="hero-subtitle">
          Evidence-based diagnosis, institutional design, implementation architecture,
          and governance-aligned evaluation.
        </h3>

        <p className="hero-text">
          Public policy is not only about choosing objectives. It requires coherent
          institutional architecture, aligned incentives, operational systems,
          accountability frameworks, and long-term governance design.
        </p>

        <div className="button-group">
          <button className="primary-btn">
            Submit a Policy / Governance Enquiry
          </button>
          <button className="secondary-btn">
            Request a Guided Policy Diagnosis
          </button>
        </div>

        {/* Public Systems Reality */}
        <h2 className="section-title">The Public Systems Reality</h2>

        <p className="section-intro">
          Governments and policymakers operate under conditions of:
        </p>

        <ul className="problem-list">
          <li>Multiple objectives and competing priorities</li>
          <li>Budget constraints and rigid financial cycles</li>
          <li>Legal and procurement compliance frameworks</li>
          <li>Capacity asymmetries across departments</li>
          <li>Political and reputational sensitivity</li>
          <li>Implementation complexity across regions</li>
          <li>Data fragmentation and weak feedback loops</li>
        </ul>

        <p className="insight-text">
          Many public outcomes do not fail due to lack of intent, but due to institutional
          design gaps and coordination breakdowns.
        </p>

        {/* Core Governance Challenges */}
        <h2 className="section-title">Where Public Systems Typically Struggle</h2>

        <ol className="challenges-list">
          <li>
            <strong>Institutional Architecture</strong><br />
            Undefined accountability lines, overlapping mandates, weak coordination.
          </li>
          <li>
            <strong>Policy-to-Execution Gap</strong><br />
            Well-designed policy without operational sequencing.
          </li>
          <li>
            <strong>Monitoring & Evaluation Weakness</strong><br />
            Indicators not linked to decision systems.
          </li>
          <li>
            <strong>Capacity & Capability Constraints</strong><br />
            Skill asymmetry across administrative layers.
          </li>
          <li>
            <strong>Learning & Adaptation Deficit</strong><br />
            Limited structured feedback into policy redesign.
          </li>
        </ol>

        {/* Structured Solution Architecture */}
        <h2 className="section-title">Structured Solution Architecture</h2>

        <p className="note-text">
          This section shows only the most relevant solution pathways for governments.
        </p>

        {/* Section 1 */}
        <h3 className="subsection-title">
          SECTION A: Policy Diagnosis & Institutional Design
        </h3>

        <p className="provider">
          Delivered through: Vasudheva Strategic Innovations Pvt. Ltd.
        </p>

        <ul className="focus-list">
          <li>Policy and program diagnostics</li>
          <li>Institutional role and accountability mapping</li>
          <li>Governance design frameworks</li>
          <li>Inter-department coordination models</li>
          <li>Theory of change development</li>
        </ul>

        <button className="btn explore">
          Explore Policy & Governance Architecture
        </button>

        {/* Section 2 */}
        <h3 className="subsection-title">
          SECTION B: Implementation & Operating Models
        </h3>

        <ul className="focus-list">
          <li>Implementation sequencing</li>
          <li>Standard operating procedure design</li>
          <li>Capacity mapping and restructuring</li>
          <li>District/block harmonisation</li>
          <li>Citizen feedback integration systems</li>
        </ul>

        <button className="btn explore">
          Explore Implementation Architecture
        </button>

        {/* Section 3 */}
        <h3 className="subsection-title">
          SECTION C: Monitoring, Evaluation & Learning Systems
        </h3>

        <ul className="focus-list">
          <li>Outcome framework design</li>
          <li>Monitoring systems linked to decisions</li>
          <li>Evaluation design (process / outcome / impact)</li>
          <li>Learning loops and structured iteration</li>
        </ul>

        <button className="btn explore">
          Explore Monitoring & Evaluation Systems
        </button>

        {/* Engagement Start */}
        <h2 className="section-title">
          Submit a Policy / Governance Enquiry
        </h2>

        <div className="button-group">
          <button className="primary-btn">Submit Enquiry</button>
          <button className="secondary-btn">Request Guided Policy Diagnosis</button>
        </div>

        <p className="form-note">
          Please share only what you are authorised to disclose.
          Formal confidentiality arrangements can be initiated where required.
        </p>

        {/* Footer */}
        <p className="footer-note">
          Vasudheva Holdings Pvt. Ltd. serves as the governance and integration nucleus
          of the Group. All engagements are undertaken under formal agreement with the
          relevant entity.
        </p>

      </div>
    </section>
  );
}
